import { AxiosInstance } from 'axios';
import { DataFetcherFunction } from '@/compiler/types';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import { userInterface, UserUuid } from '../users';

export type AdminPlatformRole = 'developer' | 'customer_service' | 'partner';

export interface AdminUser extends userInterface {
    platformRoles: AdminPlatformRole[]
}

// The backend has not documented this operation in the OpenAPI contract yet, so its wire shape is hand-written.
export interface AdminOauthAuthorizableAccount {
    uuid: string
    type: 'service_provider' | 'merchant'
    name: string
}

const partnerAccessUrl = (userUuid: UserUuid): string => `/api/admin/users/${encodeURIComponent(userUuid)}/partner-access`;

export default (axios: AxiosInstance = baseAxios): {
    searchUsers: DataFetcherFunction<AdminUser>
    grantPartnerAccess: (userUuid: UserUuid) => Promise<AdminUser>
    removePartnerAccess: (userUuid: UserUuid) => Promise<AdminUser>
    fetchOauthAuthorizableAccounts: (userUuid: UserUuid) => Promise<AdminOauthAuthorizableAccount[]>
} => ({
    searchUsers: fetchPaginatedDataFunction<AdminUser>('/api/admin/users/search', undefined, axios),

    grantPartnerAccess: async (userUuid: UserUuid): Promise<AdminUser> => {
        const response = await axios.put<{ data: AdminUser }>(partnerAccessUrl(userUuid));

        return response.data.data;
    },

    removePartnerAccess: async (userUuid: UserUuid): Promise<AdminUser> => {
        const response = await axios.delete<{ data: AdminUser }>(partnerAccessUrl(userUuid));

        return response.data.data;
    },

    fetchOauthAuthorizableAccounts: async (userUuid: UserUuid): Promise<AdminOauthAuthorizableAccount[]> => {
        const response = await axios.get<{ data: AdminOauthAuthorizableAccount[] }>(`/api/admin/users/${encodeURIComponent(userUuid)}/oauth-authorizable-accounts`);

        return response.data.data;
    },
});
